import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import classNames from "classnames";
import { toast } from "sonner";

import { CCard, CCardBody } from "@coreui/react";

import { comboApi } from "src/1/apis/combo.api";
import { CTable } from "src/1/common/components/others";
import { history, warningDelete } from "src/App";
import { CCheckbox } from "src/common/components/controls";

import { ComboSuggestToolbar } from "../../components";

const DanhSachDeXuatCombo = () => {
  //#region Data
  const [params, setParams] = useState({
    page: 1,
    size: 10,
    status: "",
    name: "",
    code: "",
  });

  const [selectedId, setSelectedId] = useState("");

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["danh-sach-de-xuat-combo", params],
    queryFn: () => comboApi.getPaginateProposals(params),
    select: (response) => response?.data,
  });

  const listData = useMemo(() => data?.data ?? [], [data]);
  //#endregion

  //#region Event
  const onLimitChange = (newLimit) =>
    setParams((prev) => ({
      ...prev,
      page: 1,
      size: newLimit,
    }));

  const onPageChange = (newPage) =>
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));

  const onSearch = (data) =>
    setParams((prev) => ({ ...prev, ...data, page: 1 }));

  const onAdd = () => history.push("/combos/create-suggest");

  const onEdit = () => {
    history.push(`/combos/edit-suggest/${selectedId}`);
  };

  const onRemove = () => {
    warningDelete({
      onConfirm: () => comboApi.removeProposal(selectedId),
      onSuccess: () => {
        refetch();
        return "Xóa thành công";
      },
      onError: (error) => error?.message || "Xóa không thành công!",
    });
  };

  const onApprove = async () => {
    try {
      await comboApi.approveProposal(selectedId);
      refetch();
      toast.success("Duyệt combo thành công!");
    } catch (error) {
      toast.error(error?.message || "Lỗi");
    }
  };
  //#endregion

  //#region Render
  const headers = [
    {
      key: "selection",
      label: "",
      align: "center",
      width: 30,
      cellRender: (value, record) => (
        <CCheckbox
          disabled={Math.abs(record?.approved_status) === 1}
          value={selectedId === record?.id}
          onChange={() => {
            if (selectedId === record?.id) {
              setSelectedId("");
            } else {
              setSelectedId(record?.id);
            }
          }}
        />
      ),
    },
    {
      key: "code",
      label: "Mã Combo",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => history.push(`/combos/proposal-detail/${record.id}`)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "name",
      label: "Tên Combo",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => history.push(`/combos/proposal-detail/${record.id}`)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "cost",
      label: "Tổng giá trị giá cost",
      align: "right",
      columnType: "number",
    },
    {
      key: "unit",
      label: "Đơn vị tính",
    },
    {
      key: "created_by",
      label: "Người đề xuất",
      align: "left",
    },
    {
      key: "role_name",
      label: "Trạng thái",
      cellRender: (value, record) => (
        <span
          className={classNames(
            record?.approved_status === 1 && "text-green-600 font-medium",
            record?.approved_status === -1 && "text-red-700 font-medium",
          )}
        >
          {value}
        </span>
      ),
    },
    {
      key: "from",
      label: "Áp dụng từ ngày",
      columnType: "date",
    },
    {
      key: "to",
      label: "Đến ngày",
      columnType: "date",
    },
    {
      key: "note",
      label: "Ghi chú",
      align: "left",
    },
  ];
  return (
    <>
      <ComboSuggestToolbar
        params={params}
        onEdit={onEdit}
        onRemove={onRemove}
        onSearch={onSearch}
        onApprove={onApprove}
        onAdd={onAdd}
        canEdit={!!selectedId}
        canRemove={!!selectedId}
        canApprove={!!selectedId}
      />

      <CCard>
        <CCardBody className="pt-0 px-0">
          <div className="mt-3">
            <CTable
              loading={isFetching}
              headers={headers}
              data={listData}
              fontSizeBody={16}
              divider
              page={params?.page}
              pages={data?.metadata?.last_page}
              limit={params?.size}
              total={data?.metadata?.total}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
            />
          </div>
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachDeXuatCombo;
